import { Button, Container, Grid, Typography } from "@pmberjaya/cloudbank-ui";
import React from "react";
import { CallIcon, ChatIcon, EmailIcon } from "../../Common/Icon";
import Section from "../../Common/Section";

const ContactPage = () => {
  return (
    <Section>
      <Typography variant="h2" className="text-heading-h2" alignText="center">
        AYO HUBUNGI KAMI
      </Typography>
      <Typography className="text-paragraf" alignText="center">
        Silahkan pilih Cara yang paling nyaman untuk Anda
      </Typography>
      <Grid row>
        <Grid mt={5} md={6} lg={3}>
          <div className="text-center contact-section">
            <EmailIcon width="100" height="100" className="text-primary" />
            <Typography
              variant="h3"
              className="text-heading-h4"
              color="primary"
              mt={3}
            >
              Email & Trouble Ticket
            </Typography>
          </div>
          <div className="contact-section">
            <Typography className="text-paragraf">
              Kami selalu merespon email dalam hitungan menit. Anda tak akan
              merasa bertepuk sebelah tangan.
            </Typography>
          </div>
          <Typography variant="h4" className="text-heading-h4">
            Sales & Informasi Umum:
          </Typography>
          <Typography className="text-paragraf">admin@cloudbank.id</Typography>
          <Typography variant="h4" className="text-heading-h4">
            Dukungan Teknis
          </Typography>
          <Typography variant="h4" className="text-heading-h4">
            Billing
          </Typography>
          <Typography variant="h4" className="text-heading-h4">
            Abuse/Pelanggaran
          </Typography>
        </Grid>
        <Grid mt={5} md={6} lg={3}>
          <div className="text-center contact-section">
            <ChatIcon width="100" height="100" className="text-primary" />
            <Typography
              variant="h3"
              className="text-heading-h4"
              color="primary"
              mt={3}
            >
              Ngobrol via Chat
            </Typography>
          </div>
          <div className="contact-section">
            <Typography className="text-paragraf">
              Punya pertanyaan atau ingin konsultasi? Jangan ragu untuk langsung
              ngobrol dengan tim Cloudbank.
            </Typography>
          </div>
          <Typography variant="h4" className="text-heading-h4">
            Sales & Informasi Umum:
          </Typography>
          <Typography className="text-paragraf">Sales 1 : Geovaldo</Typography>
          <Typography className="text-paragraf">
            No WA : 089604424863
          </Typography>
          <Typography className="text-paragraf">
            boleh Konsultasi Gratis
          </Typography>

          <Typography variant="h4" className="text-heading-h4">
            Dukungan Teknis
          </Typography>
          <Typography className="text-paragraf">
            - Membantu untuk memberikan informasi seputar tentang Cloudbank
          </Typography>
          <Typography className="text-paragraf">
            - Membantu untuk memandu mulai dari proses pendaftaran sampai
            pembelian
          </Typography>
          <Typography className="text-paragraf">
            {" "}
            - Menjadi perantara antar Customer dan Teknisi
          </Typography>
          
        </Grid>
        <Grid mt={5} md={6} lg={3}>
          <div className="text-center contact-section">
            <CallIcon width="100" height="100" className="text-primary" />
            <Typography
              variant="h3"
              className="text-heading-h4"
              color="primary"
              mt={3}
            >
              Telepon
            </Typography>
          </div>
          <div className="contact-section">
            <Typography className="text-paragraf">
              Anda merasa lebih nyaman untuk bicara lewat telepon? Dial telepon
              Anda 24 x 7 untuk menghubungi kami
            </Typography>
          </div>
          <Typography variant="h4" className="text-heading-h4">
            Medan
          </Typography>

          <Typography variant="h4" className="text-heading-h4">
            Telkomsel
          </Typography>
          <Typography variant="h4" className="text-heading-h4">
            Indosat
          </Typography>
          <Typography variant="h4" className="text-heading-h4">
            XL
          </Typography>
        </Grid>
        <Grid mt={5} md={6} lg={3}>
          <div className="text-center contact-section">
            <ChatIcon width="100" height="100" className="text-primary" />
            <Typography
              variant="h3"
              className="text-heading-h4"
              color="primary"
              mt={3}
            >
              Kantor
            </Typography>
          </div>
          <div className="contact-section">
            <Typography className="text-paragraf">
              Untuk penanggulangan penyebaran COVID19, sementara kami tidak
              menerima kunjungan ke kantor Medan
            </Typography>
          </div>
          <Typography variant="h4" className="text-heading-h4">
            Medan
          </Typography>

          <Typography variant="h4" className="text-heading-h4">
            Batam
          </Typography>

          <Typography variant="h4" className="text-heading-h4">
            jam Pelayanan Kantor
          </Typography>
        </Grid>
      </Grid>
    </Section>
  );
};

export default ContactPage;
